import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  pageHeader: {},
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    margin: "0px",
  },
  divider: {
    margin: "20px 0px",
    color: colors.lightGrey,
    opacity: 1,
  },
  policyContainer: {
    margin: "32px 0px",
    "& h3": {
      color: colors.lightBlack,
      fontWeight: "600",
      fontSize: "18px",
      lineHeight: "28px",
      margin: 0,
    },
    "& p": {
      color: colors.mediumGrey,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      margin: "4px 0px 0px",
    },
  },
  policyCard: {
    backgroundColor: colors.gray25,
    marginTop: "24px",
    padding: "24px",
    borderRadius: "12px",
    border: "1px solid " + colors.lightGrey,
    boxShadow:
      "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1)",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "14px",
    },
  },
  policyCardRow: {
    display: "flex",
    gap: "64px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      flexDirection: "column",
      gap: "20px",
    },
  },
  policyRowName: {
    width: "280px",
    flex: "none",
    "& h6": {
      color: colors.grey,
      fontWeight: "500",
      fontSize: "14px",
      lineHeight: "20px",
      margin: 0,
    },
    "& p": {
      color: colors.mediumGrey,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      margin: 0,
    },
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      width: "200px",
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "100%",
    },
  },
  policyRowAction: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "20px",
    width: "100%",
  },
  policySearchWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    width: "100%",
    maxWidth: "400px",
  },
  policyAutocomplete: {
    position: "relative",
    width: "100%",
    "& [class^='icon']": {
      left: "14px",
      top: "50%",
      transform: "translateY(-50%)",
      "& svg": {
        display: "block",
      },
    },
  },
  fromEditMode: {
    "& [class^='icon']": {
      display: "none",
    },
    "& [class*='inputAutocomplete']": {
      padding: `0 ${theme.fromLocationPadding || 110}px 0 14px`,
    },
  },
  toEditMode: {
    "& [class^='icon']": {
      display: "none",
    },
    "& [class*='inputAutocomplete']": {
      padding: `0 ${theme.toLocationPadding || 110}px 0 14px`,
    },
  },
  selectionType: {
    position: "absolute",
    top: "10px",
    right: "47px",
    color: colors.mediumGrey,
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
  },
  inputAutocomplete: {
    width: "100%",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: colors.lightBlack,
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0px 14px 0px 42px",
    textOverflow: "ellipsis",
  },
  autocompleteOptions: {
    position: "absolute",
    zIndex: "1000",
    cursor: "pointer",
    background: colors.white,
    border: "1px solid " + colors.lightGrey,
    borderRadius: "8px",
    marginTop: "4px",
    width: "100%",
    padding: "12px",
    color: colors.mediumGrey,
    maxHeight: "500px",
    overflowY: "auto",
    boxShadow:
      "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    overflowX: "hidden",
    "& ::-webkit-scrollbar": {
      width: "12px",
    },
    "& p": {
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "18px",
      color: colors.mediumGrey,
      margin: 0,
    },
    "& ul": {
      margin: "-7px",
      padding: "0px",
    },
    "& li": {
      alignItems: "center",
      listStyleType: "none",
      padding: "10px",
      minHeight: "44px",
      fontSize: "16px",
      fontWeight: "500",
      borderRadius: "6px",
      color: colors.lightBlack,
      "&:hover": {
        background: colors.brightBlue,
      },
    },
    "& span": {
      fontSize: "16px",
      fontWeight: "400",
      color: colors.mediumGrey,
    },
  },
  policyTextLink: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    margin: 0,
    "& a": {
      textDecoration: "none",
      fontWeight: "500",
      color: colors.darkBlue,
    },
  },
  selectFieldWrapper: {
    width: "100%",
    maxWidth: "400px",
  },
  selectField: {
    width: "auto",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& svg": {
      fill: colors.grey,
    },
  },
  btnContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& div": {
      display: "flex",
      alignItems: "center",
    },
  },
  removeBtn: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    "& span": {
      marginRight: "8px",
    },
  },
  cancelBtn: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    marginRight: "12px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },
  saveBtn: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },
  inputError: {
    extend: "inputAutocomplete",
    border: "1px solid " + colors.mediumRed + " !important",
    backgroundSize: "16px 16px",
    backgroundPosition: "right",
    backgroundRepeat: "no-repeat",
    backgroundOrigin: "content-box",
  },
  inputLocationsError: {
    extend: "inputAutocomplete",
    border: "1px solid " + colors.mediumRed + " !important",
    padding: "0px 110px 0px 14px",
  },
  error: {
    display: "block",
    marginTop: "6px",
    color: colors.red,
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "left",
  },
  errorWrapper: {
    "& span": {
    extend: "error",
    },
  },
  locationsError: {
    extend: "error",
    marginTop: "-14px",
  },
  toggleLabel: {
    "& span": {
      fontSize: "16px"
    },
  }
}));

export default styles;

export const selectField = {
  option: (base, state) => ({
    ...base,
    fontSize: "14px",
    img: {
      display: state.isSelected ? "inline" : "none",
      marginLeft: "6px",
    },
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 8px",
    backgroundColor: state.isSelected ? colors.brightBlue : colors.white,
    borderRadius: "6px",
    color: colors.lightBlack,
    "&:hover": {
      backgroundColor: colors.brightBlue,
    },
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "600",
    color: colors.grey,
  }),
};

